import { AutGITablePropsB } from "../../../utils/models";

import pdfCss from "../../themed/pdf/pdf.module.scss";
import css from "../../pages/reports/pdf.module.scss";

const AutGeneralInfoTableB = (props: AutGITablePropsB) => {
  return (
    <table className={pdfCss["pdf-table"]}>
      <thead>
        <tr>
          <th>Pulse Width (ns)</th>
          <th>Digitization rate (MHz)</th>
          <th>Low Pass Filter (MHz)</th>
          <th>High Pass Filter (MHz)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowSpan={3}>{props.pulseWidth}</td>
          <td>{props.digitizationRate}</td>
          <td>{props.lowPassFilter}</td>
          <td>{props.highPassFilter}</td>
        </tr>

        <tr>
          <td className={css["table-title-grid"]}>Collection Mode</td>
          <td rowSpan={2} className={css["table-title-grid"]}>
            A/D delay (μs)
          </td>
          <td rowSpan={2} className={css["table-title-grid"]}>
            A/D Width (μs)
          </td>
        </tr>

        <tr>
          <td>{props.collectionMode}</td>
        </tr>

        <tr>
          <td className={css["table-title-grid"]}>Probe Angles</td>
          <td>{props.probeAngle} deg</td>
          <td>{props.adDelay}</td>
          <td>{props.adWidth}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default AutGeneralInfoTableB;
